var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"process-header text-700",style:(_vm.color && { backgroundColor: _vm.color }),attrs:{"title":_vm.isTruncated && _vm.name}},[_c('div',{ref:"section",staticClass:"name"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }